import React, { useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { getFullName } from 'utilities/person'
import {
    Wrapper,
    Signatories, Signatory, Meta
} from './s'
import { Label } from 'components/form/field/s'
import { Plain, Simple } from 'components/button'
import { Scrollable as Modal } from 'modals/generic'
import Add from './add'
import { Plus, X } from 'styled-icons/feather'

const ExternalSignatories = ({ externalSignatories, setExternalSignatories, salt }) => {
    const [adding, setAdding] = useState(false)

    return (
        <Wrapper>
            <Label>
                <FormattedMessage
                    id="document_label_external_signatories"
                    defaultMessage="External signatories" />
            </Label>
            <Plain
                className="constructive"
                icon={<Plus size={24} />}
                onClick={() => setAdding(true)}>
                <FormattedMessage
                    id="document_action_add_external_signatory"
                    defaultMessage="Add external signatory" />
            </Plain>
            {!!externalSignatories?.length && (
                <Signatories>
                    {externalSignatories.map((signatory, index) => (
                        <Signatory key={`${salt}:external-signatory:${signatory.email}`}>
                            <Meta>
                                <span>{getFullName(signatory)}</span>
                                {(signatory?.givenName || signatory?.familyName) && (
                                    <span>{signatory.email}</span>
                                )}
                            </Meta>
                            <Simple
                                icon={X}
                                onClick={() => setExternalSignatories(externalSignatories.filter((_, sIndex) => sIndex !== index))} />
                        </Signatory>
                    ))}
                </Signatories>
            )}
            <Modal
                show={!!adding}
                dismiss={() => setAdding(false)}>
                <Add
                    onDone={() => setAdding(false)}
                    externalSignatories={externalSignatories}
                    setExternalSignatories={setExternalSignatories}
                    salt={salt} />
            </Modal>
        </Wrapper>
    )
}

export default ExternalSignatories
